import { createStringEnum } from './create-string-enum';
import { EnumValues } from './enum-types';

// Should be the same values as are declared
// in the `LogLevel` type from the `@nestjs/common` package.
export const LogLevel = createStringEnum(['verbose', 'debug', 'log', 'warn', 'error']);
export type LogLevel = EnumValues<typeof LogLevel>;
